// loads scripts that need to be on page - every entrypoint should import this!
// import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { AdLoader } from '@datagraphics/cookbook';
import { load, lazyload } from './lazyload-update.js';

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';

let scrolled = false;

let edgeCoding;
const edgeCodingEl = document.querySelector('#edge-coding');

//all splides except topper
let articleSplides = [];

let carouselInView;
let carouselsEntered = 0;
// Write your code!

const observers = [];
const presentSteps = [];
let topDist = window.scrollY;
const logo = document.querySelector('#behold-logo');

let horizontalInView;
let isMobile = window.matchMedia('(hover:none)').matches;
let edgeCodingPace = isMobile ? -1 : -1.22;

let fadeHeight = isMobile ? 100 : 40;

let innerHeight = window.innerHeight + 50;
edgeCodingEl.style.setProperty('--edge-height', `${innerHeight}px)`);

document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();

  createCarousels();
  setUpObservers();
  setUpAudio();

  logo.addEventListener('click', function () {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
});

function setUpAudio() {
  document.querySelectorAll('.audio-box').forEach((item, i) => {
    let playButton = item.querySelector('.play');
    let audioTag = item.querySelector('audio');
    let captionTag = item.querySelector('.captions');

    playButton.addEventListener('click', function () {
      audioTag.play();
      playButton.classList.add('playing');
    });

    audioTag.addEventListener('ended', function () {
      playButton.classList.remove('playing');
      captionTag.innerHTML = captionTag.dataset.line1;
    });
    audioTag.textTracks[0].mode = 'showing';
    audioTag.textTracks[0].addEventListener('cuechange', function () {
      captionTag.innerHTML = this.activeCues[0] ? this.activeCues[0].text : '';
    });
  });
}

function createCarousels() {
  //top slides
  new Splide('#top-carousel', {
    type: 'loop',
    arrows: false,
    gap: '8px',
    pagination: false,
    autoWidth: true,
    autoHeight: true,
    focus: 'center',
    autoplay: true,
    interval: 2000,
    pauseOnHover: false,
    updateOnMove: true,
    drag: false,
  }).mount();

  //edge coding

  let codingHeight = document.querySelector('#item-wrapper').innerHeight;

  edgeCoding = new Splide('#edge-coding', {
    type: 'loop',
    arrows: false,
    pagination: false,
    direction: 'ttb',
    height: codingHeight + 'px',
    drag: false,
    autoScroll: {
      speed: 0.75,
    },
  });

  if (isMobile) {
    edgeCoding.mount({ AutoScroll, Intersection });
  } else {
    edgeCoding.mount();
  }

  let smallLoop = new Splide('.infinite-scroll.small', {
    type: 'loop',
    arrows: false,
    gap: '8px',
    pagination: false,
    autoWidth: true,
    autoHeight: true,
    pauseOnHover: false,
    drag: false,
    label: 'A moving carousel of portraits taken in a photography studio',
  }).mount({ AutoScroll, Intersection });

  articleSplides.push(smallLoop);

  let oldScroll = window.scrollY;

  const interstitials = [...document.querySelectorAll('.interstitial')];
  let interstitialSplides = [];

  buildInterstitials();

  function buildInterstitials() {
    for (var carousel of interstitials) {
      let spl = new Splide(carousel, {
        type: 'loop',
        arrows: false,
        gap: '16px',
        pagination: false,
        autoWidth: true,
        autoHeight: true,
        pauseOnHover: false,
        drag: false,
      });

      if (isMobile) {
        spl.mount({ AutoScroll, Intersection });
      } else {
        spl.mount({ Intersection });
      }

      carousel.dataset.pos = 0;

      spl.on('intersection:in', function (entry) {
        carouselInView = spl;
        carouselsEntered++;
        entry.target.dataset.start_point = window.scrollY;
      });
      spl.on('intersection:out', function (entry) {
        if (carouselsEntered < 2) {
          carouselInView = undefined;
        }
        carouselsEntered = carouselsEntered == 0 ? 0 : carouselsEntered - 1;
      });

      interstitialSplides.push(spl);
    }

    articleSplides = articleSplides.concat(interstitialSplides);
  }
}

window.addEventListener('scroll', function () {
  if (window.scrollY > fadeHeight && !scrolled) {
    document.querySelector('body').classList.add('scrolled');
    scrolled = true;
    console.log('add');
  } else if (window.scrollY < fadeHeight && scrolled) {
    document.querySelector('body').classList.remove('scrolled');
    scrolled = false;
    console.log('remove');
  }

  if (!isMobile) {
    edgeCoding.Components.Move.translate(window.scrollY * edgeCodingPace);
    if (carouselInView) {
      let offset = carouselInView.root.dataset.start_point;
      carouselInView.Components.Move.translate(offset - window.scrollY);
    }
  }

  if (horizontalInView) {
    let offset = horizontalInView.dataset.start_point;
    horizontalInView
      .querySelector('.track')
      .style.setProperty(
        '--shift',
        `max(calc(var(--track-length) * -1),${Math.min(
          0,
          offset - window.scrollY
        )}px)`
      );
    // horizontalInView.querySelector('.track').style.transform=`translateX(${Math.min(0,offset - window.scrollY)}px)`;
  }

  // document.documentElement.style.setProperty('--scroll-dist', window.scrollY);
});

function setUpObservers() {
  //horizontal scroll
  let margin = isMobile ? '20px' : '5px';
  createObserver({
    root: null,
    rootMargin: `${margin} 0px ${margin} 0px`,
    threshold: 0.9,
    callback: horizontalDetect,
    step: '.step',
  });

  //shrink eye
  createObserver({
    root: null,
    rootMargin: `-20px 0px 0px 0px`,
    threshold: 1.0,
    callback: logoShrink,
    step: '#behold-logo',
  });

  createObserver({
    root: null,
    rootMargin: '300px 0%',
    callback: customLazy,
    step: '.infinite-scroll:not(#top-carousel)',
  });
}

function customLazy(entries) {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting || entry.intersectionRatio) {
      const target = entry.target;
      if (target.dataset.loaded == 'false') {
        let spl = articleSplides[target.dataset.step];
        spl.Components.Slides.forEach((slide, s) => {
          load(slide.slide.querySelector('picture'), true);
        });
        target.dataset.loaded = 'true';
      }
    }
  });
}

function logoShrink(entries) {
  if (entries[0].intersectionRatio < 1) {
    logo.classList.add('shrunk');
  } else {
    logo.classList.remove('shrunk');
  }
}

function horizontalDetect(entries) {
  if (entries[0].intersectionRatio < 0.9) {
    horizontalInView = undefined;
    edgeCodingEl.classList.remove('horizontal-mode');
  } else {
    entries[0].target.dataset.start_point =
      entries[0].target.parentNode.offsetTop;
    horizontalInView = entries[0].target;
    edgeCodingEl.classList.add('horizontal-mode');
  }
}

function createObserver(d) {
  let callback = d.callback;

  let options = {
    root: d.root,
    rootMargin: d.rootMargin,
    threshold: d.threshold,
  };

  observers.push(new IntersectionObserver(callback.bind(topDist), options));
  let ind = observers.length - 1;

  presentSteps.push(0);
  let currentObserver = observers[ind];
  let presentStep = presentSteps[ind];
  let currentInd = observers.length - 1;
  document.querySelectorAll(d.step).forEach((item, i) => {
    item.dataset.step = i;
    currentObserver.observe(item);
  });

  // window.addEventListener('resize', function () {
  //   currentObserver.disconnect();
  // });
}
